<template>
    <div class="habilitation-section">
        <p class="habilitation-section__title"><strong>Seus dados</strong></p>
        <p class="habilitation-section__hint">
            Sua conta na Área do Credor é criada no envio deste pedido. Depois, enviaremos um e-mail
            para você definir sua senha e acompanhar a análise. Já tem conta?
            <a href="#" @click.prevent="$emit('login')">Entre aqui</a>.
        </p>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    v-model="form.creditor_type"
                    :items="profiles"
                    item-value="id"
                    item-text="name"
                    label="Tipo de credor"
                    :disabled="disabled"
                    :rules="[$rules.required]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="form.registration"
                    :label="profile && profile.registration === 'cnpj' ? 'CNPJ' : 'CPF'"
                    v-mask="profile && profile.registration === 'cnpj' ? $masks.cnpj : $masks.cpf"
                    inputmode="numeric"
                    :disabled="disabled || !profile"
                    :rules="[
                        $rules.required,
                        profile && profile.registration === 'cnpj' ? $rules.cnpj : $rules.cpf
                    ]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="form.name"
                    :label="profile ? profile.nameLabel : 'Nome completo'"
                    :disabled="disabled"
                    :rules="[$rules.required]"
                    autocomplete="name"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="form.email"
                    label="E-mail"
                    type="email"
                    autocomplete="email"
                    :disabled="disabled"
                    :rules="[$rules.required, $rules.email]"
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12">
                <v-file-input
                    v-model="form.document"
                    :label="profile ? profile.documentLabel : 'Documento de identificação'"
                    accept="application/pdf, image/png, image/jpeg"
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    :disabled="disabled"
                    :rules="[$rules.required, $rules.fileSize(maxFileSizeMb)]"
                    show-size
                    outlined
                    dense
                    hide-details="auto"
                />
            </v-col>
            <v-col cols="12">
                <v-checkbox
                    v-model="form.terms"
                    :disabled="disabled"
                    :rules="[(accepted) => !!accepted || 'É preciso aceitar para continuar']"
                    hide-details="auto"
                    class="mt-0"
                >
                    <template #label>
                        <span
                            >Li e concordo com os
                            <a href="/#/termos-de-uso" target="_blank" rel="noopener" @click.stop
                                >termos de uso</a
                            >
                            e a
                            <a href="/#/polices-privacy" target="_blank" rel="noopener" @click.stop
                                >Política de Privacidade</a
                            >.</span
                        >
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import profiles, { getCreditorProfile } from '@/common/creditor-profiles.data';

export default {
    name: 'CreditorDataSection',
    props: {
        value: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
        maxFileSizeMb: { type: Number, default: 10 }
    },
    data() {
        return { form: this.value, profiles };
    },
    computed: {
        profile() {
            return getCreditorProfile(this.form.creditor_type);
        }
    },
    watch: {
        value(next) {
            this.form = next;
        },
        'value.creditor_type'() {
            // CPF e CNPJ têm máscaras diferentes; o valor anterior deixa de valer.
            this.form.registration = '';
        }
    }
};
</script>
